import React from 'react';
import { Col, Row, Typography, Card } from 'antd';
import { Explore_World } from '../../../utils/ImagePath';

const { Title, Link } = Typography;


const Explore = () => {

    return (
        <>
            <section className="Explore-area ptb-70 pb-5">
                <div className="container">
                    <div className="section-title justify-content-center">
                        <div className='text-center'>
                            <Title level={2} className="mb-1 mt-4 offer-card__text box-title">
                                Let’s Explore the world with us
                            </Title>
                            <img loading="lazy" src={Explore_World} alt='#' width={1016} height={199}></img>
                        </div>
                    </div>
                    <Row gutter={20} className="justify-content-center d-none">
                        <Col md={8} xs={24}>
                            <Card>
                                <h2 className='mb-1'>Can I Travel To...</h2>
                                <p className='mb-2'>Vitae eu praesent aliquam viverra metus erat. Donec eget dictumst id arcu in tempor. psum</p>
                                <Link className='btn btn-primary'>Explore</Link>
                            </Card>
                        </Col>
                        <Col md={8} xs={24}>
                            <Card>
                                <h2 className='mb-1'>Track Your Flight Status</h2>
                                <p className='mb-2'>Vitae eu praesent aliquam viverra metus erat. Donec eget dictumst id arcu in tempor. psum</p>
                                <Link className='btn btn-primary'>Track Flight</Link>
                            </Card>
                        </Col>
                        <Col md={8} xs={24}>
                            <Card>
                                <h2 className='mb-1'>Track YourVisa Status</h2>
                                <p className='mb-2'>Vitae eu praesent aliquam viverra metus erat. Donec eget dictumst id arcu in tempor. psum</p>
                                <Link className='btn btn-primary'>Track Visa</Link>
                            </Card>
                        </Col>
                    </Row>
                </div>

            </section>

        </>
    )
}

export default Explore
